import HasToBeLoggedInGuard from 'app/core/guards/HasToBeLoggedInGuard';
import DefaultLayout from 'app/core/layout/DefaultLayout';
import Error404Page from 'app/main/errors/Error404Page';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { HasToBeAllowedForInspectionsGuard } from '../../guards/HasToBeAllowedForInspectionsGuard';

const InspectionReportPage = lazy(
  () => import('../../../main/dcra-inspections/inspection-report/InspectionReportPage')
);

const JobCreatePage = lazy(() => import('../../../main/dcra-inspections/job-create/JobCreatePage'));
const InspectionsPage = lazy(() => import('../../../main/dcra-inspections/inspections/InspectionsPage'));
const InspectionDetailsPage = lazy(() => import('../../../main/construction/inspections/InspectionDetailsPage'));

const PREFIX = '/dcra-inspections';

const dcraInspectionRoutes: RouteObject[] = [
  {
    path: PREFIX,
    element: (
      <HasToBeLoggedInGuard>
        <HasToBeAllowedForInspectionsGuard>
          <DefaultLayout />
        </HasToBeAllowedForInspectionsGuard>
      </HasToBeLoggedInGuard>
    ),
    errorElement: <Error404Page />,
    children: [
      {
        path: 'inspection-create/:type',
        element: (
          <Suspense fallback={<DataLoader />}>
            <JobCreatePage />
          </Suspense>
        ),
      },
      {
        path: 'inspection-create',
        element: (
          <Suspense fallback={<DataLoader />}>
            <JobCreatePage />
          </Suspense>
        ),
      },
      {
        path: 'inspections/:sectionId',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectionsPage />
          </Suspense>
        ),
      },
      {
        path: 'inspections',
        element: <Navigate to={'scheduled'} />,
      },
      {
        path: 'inspection/:id/report',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectionReportPage />
          </Suspense>
        ),
      },
      {
        path: 'inspection/:id',
        element: <Suspense fallback={<DataLoader />}>{<InspectionDetailsPage />}</Suspense>,
      },
    ],
  },
  {
    path: '/',
    element: (
      <HasToBeLoggedInGuard>
        <HasToBeAllowedForInspectionsGuard>
          <DefaultLayout />
        </HasToBeAllowedForInspectionsGuard>
      </HasToBeLoggedInGuard>
    ),
    errorElement: <Error404Page />,
    children: [
      {
        path: 'dir/:id',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectionReportPage />
          </Suspense>
        ),
      },

      {
        path: 'di/:id',
        element: <Suspense fallback={<DataLoader />}>{<InspectionDetailsPage />}</Suspense>,
      },
    ],
  },
];

export default dcraInspectionRoutes;
